import { ButtonVariant, CoButton } from "components/CoButton";
import Popover from "components/Popover";
import SnapshotTooltip from "components/Popover/SnapshotTooltip";
import useCredits from "features/User/hooks/useCredits";
import useLabels from "hooks/useLabels";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { CreditedFeature } from "store/slices/subscription";

interface SnapshotToggleButtonProps {
  isSnapshotOpen: boolean;
  disabled?: boolean;
  tooltipDisabled?: boolean;
  onToggleSnapshot: () => void;
  buttonClassName?: string;
}

export const SnapshotToggleButton = ({
  isSnapshotOpen,
  disabled,
  tooltipDisabled,
  onToggleSnapshot,
  buttonClassName,
}: SnapshotToggleButtonProps) => {
  const { isPremium } = useCredits();
  const [tableLabel, snapshotToggleLabel] = useLabels(
    "consensus-meter.table",
    "consensus-meter.snapshot-toggle"
  );
  const [tooltipInstance, setTooltipInstance] = useState<any>(null);
  const handleClickUpgradePremium = () => {
    tooltipInstance?.hide();
  };

  const buttonLabel = isSnapshotOpen
    ? snapshotToggleLabel["close-details"]
    : snapshotToggleLabel["all-details"];

  const button = (
    <CoButton
      aria-label={buttonLabel}
      label={buttonLabel}
      size="sm"
      variant={ButtonVariant.Tertiary}
      iconRight={
        isSnapshotOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />
      }
      disabled={disabled}
      onClick={onToggleSnapshot}
      className={buttonClassName}
    />
  );

  if (isPremium) {
    return button;
  }

  const tooltipContentMarkup = isSnapshotOpen ? (
    <p className="normal text-center max-w-[234px]">
      {tableLabel["close-snapshot"]}
    </p>
  ) : (
    <SnapshotTooltip
      snapshotType={CreditedFeature.CONSENSUS_SNAPSHOT}
      onClickUpgradePremium={handleClickUpgradePremium}
    />
  );

  return (
    <Popover
      interactive
      maxWidth={334}
      touch={false}
      onShown={(instance: any) => {
        setTooltipInstance(instance);
      }}
      onHidden={(instance: any) => {
        setTooltipInstance(instance);
      }}
      theme={isSnapshotOpen ? "dark" : "light"}
      disabled={tooltipDisabled}
      tooltipContent={tooltipContentMarkup}
    >
      {button}
    </Popover>
  );
};
